export default function createTab() {
  let button = $('.tab-button');
  let content = $('.tab-content');

  button.on('click', function (event) {
    let id = $(this).data('tab');

    event.preventDefault();

    content.removeClass('active');
    button.removeClass('active');
    $(this).addClass('active');
    $(`#${id}`).addClass('active');
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tab.js